export default __webpack_public_path__ + "static/media/three.a9e5047a.jpg";